import QuotationService from '_services/rest/modules/quotation';
import { ROW } from '_modules/quotation/components/QuotationModel';

export default {
  state: {
    quotation: null,
    quotationList: null,
    expositionType: null,
    paymentTypeOptions: null,
  },
  mutations: {
    setExpositionType(state, response) {
      state.expositionType = response;
    },
    setQuotation(state, response) {
      state.quotation = response;
      if (response.rows.length === 0) {
        state.quotation.rows = [{ ...ROW }];
      }
    },
    setQuotationList(state, response) {
      state.quotationList = response;
    },
    setPaymentTypeOptions(state, response) {
      state.paymentTypeOptions = response;
    },
  },
  actions: {
    getExpositionType({ commit }, params) {
      return QuotationService.getExpositionTypeOptions(params)
        .then(response => {
          commit('setExpositionType', response);
        });
    },
    getQuotation({ commit }, params) {
      return QuotationService.getQuotationById(params)
        .then(response => {
          commit('setQuotation', response);
        });
    },
    getQuotationList({ commit }, params) {
      return QuotationService.getList(params)
        .then(response => {
          commit('setQuotationList', response);
        });
    },
    getPaymentTypeOptions({ commit }) {
      return QuotationService.getPaymentTypeOptions()
        .then(response => {
          commit('setPaymentTypeOptions', response);
        });
    },
  },
};
